import script from "./Publication.vue?vue&type=script&setup=true&lang=js"
export * from "./Publication.vue?vue&type=script&setup=true&lang=js"

import "./Publication.vue?vue&type=style&index=0&id=5b673806&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b673806"]])

export default __exports__